//interfaces
import { feedSourceStatus, ISourceListItem } from "@/interfaces/CombinedFeed";

//components
import { BasicButton, IconButton, IconLibrary, LoadingSpinner, ThriveIcon } from "thrive-components";



export const AddedActionButtons = ({ contentId, isAlteringContentItem, isRefreshingFeed, onRemoveSourceListClick}: { contentId: number, isAlteringContentItem: boolean, isRefreshingFeed: boolean, onRemoveSourceListClick: (id: number)=>void }) => {
    const isLoading = isAlteringContentItem || isRefreshingFeed;
    return (
        <>                
        <IconButton 
            key={`${contentId}-remove-dash`}
            ariaLabel={'remove from source list'} 
            iconName={IconLibrary.DASH_CIRCLE} 
            className={`remove-source-list-content-button`} 
            onButtonClick={() => onRemoveSourceListClick(contentId)} 
            isDisabled={isLoading}  
        />
                        
        <BasicButton 
            key={`${contentId}-add-button`}
            className={`${isAlteringContentItem ? "loading-button" : "added-source-list"} add-to-source-list-button`}
            onButtonClick={() => onRemoveSourceListClick(contentId)}
            ariaLabel={'remove from source list'}  
            isDisabled={isLoading}    
            content={
                isAlteringContentItem
                ?   <LoadingSpinner key={`${contentId}-spinner`} size={10} />
                :   <>
                    Added
                    <ThriveIcon
                        className="added-check-icon"
                        iconName={IconLibrary.CHECK}
                        color={isLoading ? "var(--thriveGrey)" : "var(--thriveGreen)"}
                        sizeInPx="12"
                    />
                    </>
            }
        />
        </>
    );
};

export const NotAddedActionButtons = ({contentId, isAlteringContentItem, isRefreshingFeed, addToSourceListClick }: {contentId: number, isAlteringContentItem: boolean, isRefreshingFeed: boolean, addToSourceListClick: (contentId: number)=>void}) => {
    const isLoading = isAlteringContentItem || isRefreshingFeed;
    return (
        <BasicButton 
            key={`${contentId}-add-button`}
            className={`${isAlteringContentItem ? "loading-button" : ""} add-to-source-list-button`}
            onButtonClick={() => addToSourceListClick(contentId)}
            ariaLabel={'Add to Source List'}  
            isDisabled={isLoading}       
            content={ 
                isAlteringContentItem
                ?   <LoadingSpinner key={`${contentId}-spinner`} size={10} />
                :   "Add"
            }
        />
    );
};

export const AddedByDefaultActionButton = ({isAlteringContentItem, isRefreshingFeed}: { isAlteringContentItem: boolean, isRefreshingFeed: boolean}) => {
    const isLoading = isAlteringContentItem || isRefreshingFeed;
    return (        
        <span className={`${isLoading ? "parent-list-added-loading" : ""} parent-list-added`}>
            Added
            <ThriveIcon
                className="added-check-icon"
                iconName={IconLibrary.CHECK}
                color={isLoading ? "var(--thriveGrey)" : "var(--thriveGreen)"}
                sizeInPx="12"
            />
        </span>
    );
};

export function getSourceListActionComponent(content: ISourceListItem, isAlteringContentItem: boolean, isRefreshingFeed: boolean, addToSourceListClick: (listId: number) => void, onRemoveSourceListClick: (listId: number) => void) {
    switch (content.feedSourceListStatus) {
        case feedSourceStatus.full:
            return (
                <AddedActionButtons
                    contentId={content.id}
                    isAlteringContentItem={isAlteringContentItem}
                    isRefreshingFeed={isRefreshingFeed}
                    onRemoveSourceListClick={onRemoveSourceListClick}
                />
            );
        case feedSourceStatus.default:
            return (
                <AddedByDefaultActionButton
                    isAlteringContentItem={isAlteringContentItem}
                    isRefreshingFeed={isRefreshingFeed}
                />
            );
        case feedSourceStatus.none:
            return (
                <NotAddedActionButtons
                    contentId={content.id}
                    isAlteringContentItem={isAlteringContentItem}
                    isRefreshingFeed={isRefreshingFeed}
                    addToSourceListClick={addToSourceListClick}
                />
            );

        default:
            return null;
    }
}